<template>
  <div class="wrapper card-wrapper">
    <h1 class="p-standard-h1">新規会員登録</h1>
    <ol class="p-formchart">
      <li class="active">
        <div class="step">1</div>
        <div class="label">入力</div>
      </li>
      <div class="spacer"></div>
      <li>
        <div class="step">2</div>
        <div class="label">確認</div>
      </li>
      <div class="spacer"></div>
      <li>
        <div class="step">3</div>
        <div class="label">完了</div>
      </li>
    </ol>
    <p v-if="err.isErr" class="p-errmsg">
      <span>
        <img src="@/assets/attention.png" alt="エラー" width="22" height="22" />
      </span>
      {{ err.msg }}
    </p>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form id="profile-change-form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="profile-change-field">
          <label class="p-form-title" for="name">パスワード<span class="required">必須</span></label>
          <div class="input-wrapper">
            <ValidatedInput
              v-model="form.password" vid="password" placeholder="半角英数字8文字以上" type="password" name="パスワード" id="password" rules="required|min:8" class="inner-input-wrapper" autocomplete="password"
            />
          </div>
        </div>
        <div class="profile-change-field">
          <label class="p-form-title" for="name">パスワード（確認）<span class="required">必須</span></label>
          <div class="input-wrapper">
            <ValidatedInput
              v-model="form.passwordConfirm" :expandedTooltip="true" type="password" name="パスワード確認" id="password-confirm" rules="required|confirmed:password" class="inner-input-wrapper" autocomplete="password"
            />
          </div>
        </div>
        <div class="profile-change-field align-start">
          <label class="p-form-title" for="name">お名前<span class="required">必須</span></label>
          <div class="input-wrapper name-input-wrapper">
            <ValidatedInput
              v-model="form.sei" placeholder="姓" type="text" name="姓" id="family-name" rules="required|max:80" class="inner-input-wrapper" autocomplete="family-name"
            />
            <ValidatedInput
              v-model="form.mei" placeholder="名" type="text" name="名" id="given-name" rules="required|max:40" class="inner-input-wrapper top-margin" autocomplete="given-name"
            />
          </div>
        </div>
        <div class="profile-change-field align-start">
          <label class="p-form-title" for="name">フリガナ<span class="required">必須</span></label>
          <div class="input-wrapper name-input-wrapper">
            <ValidatedInput
              v-model="form.seikana" placeholder="セイ" class="inner-input-wrapper" type="text" name="セイ" id="phonetic-family-name" rules="required|max:255"
            />
            <ValidatedInput
              v-model="form.meikana" placeholder="メイ" class="top-margin inner-input-wrapper" type="text" name="メイ" id="phonetic-given-name" rules="required|max:255"
            />
          </div>
        </div>
        <div class="profile-change-field align-start">
          <label class="p-form-title" for="addresslocal">住所<span class="required">必須</span></label>
          <div class="input-wrapper">

            <ValidatedZipField
             @input="form.zip = $event" type="text" name="郵便番号" id="zip" rules="required|zip" :expandedTooltip="true" class="inner-input-wrapper"
            />

            <PrefCitySelect :prefectureValue="form.prefecture" :cityValue="form.address" @input-prefecture="form.prefecture = $event" @input-city="form.address = $event" :prefectureList="preflist"/>
            <ValidatedInput
              v-model="form.addressLocal" placeholder="町名・番地・建物名（住所末尾まで入力）" class="top-margin inner-input-wrapper-long" type="text" name="住所" rules="required|max:255"
            />
          </div>
        </div>
        <div class="profile-change-field">
          <label class="p-form-title" for="tel">電話番号<span class="required">必須</span></label>
          <div class="input-wrapper">
            <ValidatedTelephoneField
              @input="form.tel = $event" type="tel" name="電話番号" id="tel" :expandedTooltip="true" rules="required|phone" class="inner-input-wrapper"
            />
          </div>
        </div>
        <div class="profile-change-field">
          <label class="p-form-title" for="email">メールアドレス<span class="required">必須</span></label>
          <div class="input-wrapper">
            <!-- <ValidatedInput
              v-model="form.email" placeholder="ki-group@xxxx.com" type="email" name="メールアドレス" id="email" :expandedTooltip="true" rules="required|email" class="inner-input-wrapper"
            /> -->
            {{form.email}}
          </div>
        </div>
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="family-size">生年月日<span class="required">必須</span></label>
          <div id="standard-field-input-wrapper" class="inner-input-wrapper">
            <div class="inner-input-wrapper inner-input-wrapper-fullscreen-short">
              <ValidatedDateOfBirthField
                v-model="form.dateOfBirth" name="生年月日" id="生年月日" rules="required"
              />
            </div>
          </div>
        </div> -->
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="family-size">家族構成<span class="required">必須</span></label>
          <div id="standard-field-input-wrapper" class="inner-input-wrapper">
            <div class="inner-input-wrapper inner-input-wrapper-fullscreen-short">
              <ValidatedInput
               v-model="form.familySize" placeholder="4" type="text" name="家族構成" id="family-size" rules="numeric|required"
              />
              <span class="input-suffix">人</span>
            </div>
          </div>
        </div> -->
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="currentPropertyStatus">現在お住みの物件種別<span class="required">必須</span></label>
          <div class="c-radios-wrapper">
            <div class="c-radio-wrapper" @click="form.currentPropertyStatus = '賃貸'">
              <input v-model="form.currentPropertyStatus" id="賃貸" type="radio" value="賃貸">
              <label for="賃貸"></label>
              <p>賃貸</p>
            </div>
            <div class="c-radio-wrapper" @click="form.currentPropertyStatus = '持ち主'">
              <input v-model="form.currentPropertyStatus" id="currentPropertyStatus" type="radio" value="持ち主">
              <label for="持ち主"></label>
              <p>持ち主</p>
            </div>
          </div>
        </div> -->
        <div class="profile-change-field">
          <label class="p-form-title" for="desiredKind">希望の物件種別 <span>(複数回答可）</span><span class="required">必須</span></label>
          <validation-wrapper ref="prov" class="input-wrapper" name="希望の物件種別" rules="required" :expandedTooltip="false" :tooltipPositionBottom="48">
            <div class="c-check-wrapper">
              <input v-model="form.desiredKind" type="checkbox" value="新築戸建て" id="新築戸建て">
              <label for="新築戸建て" class="c-checkbox-label"><span class="check-icon"></span>新築戸建て</label>
            </div>
            <div class="c-check-wrapper">
              <input v-model="form.desiredKind" type="checkbox" value="中古戸建て" id="中古戸建て">
              <label for="中古戸建て" class="c-checkbox-label"><span class="check-icon"></span>中古戸建て</label>
            </div>
            <div class="c-check-wrapper">
              <input v-model="form.desiredKind" type="checkbox" value="新築マンション" id="新築マンション">
              <label for="新築マンション" class="c-checkbox-label"><span class="check-icon"></span>新築マンション</label>
            </div>
            <div class="c-check-wrapper">
              <input v-model="form.desiredKind" type="checkbox" value="中古マンション" id="中古マンション">
              <label for="中古マンション" class="c-checkbox-label"><span class="check-icon"></span>中古マンション</label>
            </div>
            <div class="c-check-wrapper">
              <input v-model="form.desiredKind" type="checkbox" value="土地" id="土地">
              <label for="土地" class="c-checkbox-label"><span class="check-icon"></span>土地</label>
            </div>
        </validation-wrapper>
          </div>
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="daysOff">お休みの曜日<span class="required">必須</span></label>
          <div class="c-check-wrapper">
            <input type="checkbox" id="月" value="月" v-model="form.daysOff">
            <label for="月"><span class="check-icon"></span>月</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="火" value="火" v-model="form.daysOff">
            <label for="火"><span class="check-icon"></span>火</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="水" value="水" v-model="form.daysOff">
            <label for="水"><span class="check-icon"></span>水</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="木" value="木" v-model="form.daysOff">
            <label for="木"><span class="check-icon"></span>木</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="金" value="金" v-model="form.daysOff">
            <label for="金"><span class="check-icon"></span>金</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="土" value="土" v-model="form.daysOff">
            <label for="土"><span class="check-icon"></span>土</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="日" value="日" v-model="form.daysOff">
            <label for="日"><span class="check-icon"></span>日</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="祝日" value="祝日" v-model="form.daysOff">
            <label for="祝日"><span class="check-icon"></span>祝日</label>
          </div>
        </div> -->
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="income">世帯年収<span class="optional">任意</span></label>
          <div class="input-wrapper">
            <ValidatedSelect class="select-wrapper inner-input-wrapper" :items="incomes" rules="" name="世帯年収" v-model="form.income" id="income" placeholder="選択してください" valueKey="name" nameKey="name" />
          </div>
        </div>
        <div class="profile-change-field">
          <label class="p-form-title" for="budgets">ご予算<span class="optional">任意</span></label>
          <div class="input-wrapper">
            <ValidatedSelect class="select-wrapper inner-input-wrapper" :items="budgets" rules="" name="世帯年収" v-model="form.budget" id="income" placeholder="選択してください" valueKey="name" nameKey="name" />
          </div>
        </div> -->
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="replacement">買い替えの有無<span class="required">必須</span></label>
          <div class="c-radios-wrapper">
            <div class="c-radio-wrapper" @click="form.replacement = true">
              <input v-model="form.replacement" id="replacement-yes" type="radio" value="true">
              <label for="yes"></label>
              <p>有り</p>
            </div>
            <div class="c-radio-wrapper" @click="form.replacement = false">
              <input v-model="form.replacement" id="replacement-no" type="radio" value="false">
              <label for="no"></label>
              <p>無し</p>
            </div>
          </div>
        </div> -->
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="replacement">ご導入検討のきっかけ<span class="required">必須</span></label>
          <div class="c-radios-wrapper">
            <div class="c-radio-wrapper" @click="form.motiveForSearch = '家族のために家を持ちたい'">
              <input v-model="form.motiveForSearch" id="家族のために家を持ちたい" type="radio" value="家族のために家を持ちたい">
              <label for="家族のために家を持ちたい"></label>
              <p>家族のために家を持ちたい</p>
            </div>
            <div class="c-radio-wrapper" @click="form.motiveForSearch = '現在のざ住居費費が高くてもったいない'">
              <input v-model="form.motiveForSearch" id="現在のざ住居費費が高くてもったいない" type="radio" value="現在のざ住居費費が高くてもったいない">
              <label for="現在のざ住居費費が高くてもったいない"></label>
              <p>現在のざ住居費費が高くてもったいない</p>
            </div>
            <div class="c-radio-wrapper" @click="form.motiveForSearch = '金利が低く買い時だと思った'">
              <input v-model="form.motiveForSearch" id="金利が低く買い時だと思った" type="radio" value="金利が低く買い時だと思った">
              <label for="金利が低く買い時だと思った"></label>
              <p>金利が低く買い時だと思った</p>
            </div>
            <div class="c-radio-wrapper" @click="form.motiveForSearch = 'もっと広い家に住みたいと思った'">
              <input v-model="form.motiveForSearch" id="もっと広い家に住みたいと思った" type="radio" value="もっと広い家に住みたいと思った">
              <label for="もっと広い家に住みたいと思った"></label>
              <p>もっと広い家に住みたいと思った</p>
            </div>
            <div class="c-radio-wrapper" @click="form.motiveForSearch = 'その他（下記にご入力ください）'">
              <input v-model="form.motiveForSearch" id="その他（下記にご入力ください）" type="radio" value="その他（下記にご入力ください）">
              <label for="その他（下記にご入力ください）"></label>
              <p>その他（下記にご入力ください）</p>
            </div>
            <div class="inner-input-wrapper inner-input-wrapper-fullscreen-short">
              <ValidatedInput
               v-model="form.motiveForSearchAdditional"
               :disabled="form.motiveForSearch !== 'その他（下記にご入力ください）'"
               placeholder=""
               type="text"
               name="きっかけ"
               id="current-rent"
               :rules="form.motiveForSearch === 'その他（下記にご入力ください）' ? 'required' : ''"
              />
              <span class="input-suffix">万円</span>
            </div>
          </div>
        </div> -->
        <div class="profile-change-field" id="desired-area-field">
          <label class="p-form-title" for="income">希望エリア<span class="required">必須</span></label>
          <div class="input-wrapper">
            <PrefCitySelect :prefectureValue="form.desiredAreaPref" :cityValue="form.desiredAreaCity" @input-prefecture="form.desiredAreaPref = $event" @input-city="form.desiredAreaCity = $event" :prefectureList="limitedPrefList"/>
          </div>
        </div>
        <div class="profile-change-field">
          <label class="p-form-title" for="income">希望価格帯<span class="required">必須</span></label>
          <div class="input-wrapper">
            <div class="c-price-select-inner-input-wrapper">
              <ValidatedSelect class="select-wrapper inner-input-wrapper" :doubleSort="true" :items="priceRangesLower" rules="required|lessThan:@upper" name="ご希望の価格帯" v-model="form.desiredPriceRangeLower" id="other-budget" valueKey="value" nameKey="name" />
            </div>
            <span class="c-price-separator"> ~ </span>
            <div class="c-price-select-inner-input-wrapper">
              <ValidatedSelect class="select-wrapper inner-input-wrapper" :doubleSort="true" :items="priceRangesUpper" rules="required" vid="upper" name="ご希望の価格帯" v-model="form.desiredPriceRangeUpper" id="other-budget" valueKey="value" nameKey="name" />
            </div>
          </div>
        </div>
        <div class="profile-change-field">
          <label class="p-form-title" for="desired-monthly-price">月々の支払想定額<span class="optional">任意</span></label>
          <div id="standard-field-input-wrapper" class="inner-input-wrapper">
            <div class="inner-input-wrapper c-input-finance-field-width">
              <ValidatedInput
               v-model="form.desiredMonthlyPrice" placeholder="10" type="text" name="desired-monthly-price" id="desired-monthly-price" rules="numeric" tooltipArrowPosition="left"
              />
              <span class="input-suffix">万円</span>
            </div>
          </div>
        </div>
        <div class="profile-change-field">
          <label class="p-form-title" for="motiveForSearch">購入動機 <span class="c-label-subtitle-motive">(複数回答可）</span><span class="required">必須</span></label>
          <validation-wrapper ref="prov" class="input-wrapper" name="購入動機" rules="required" :expandedTooltip="false" :tooltipPositionBottom="48">
            <div class="c-check-wrapper">
              <input v-model="form.motiveForSearch" type="checkbox" value="ご結婚" id="ご結婚">
              <label for="ご結婚" class="c-checkbox-label"><span class="check-icon"></span>ご結婚</label>
            </div>
            <div class="c-check-wrapper">
              <input v-model="form.motiveForSearch" type="checkbox" value="ご出産" id="ご出産">
              <label for="ご出産" class="c-checkbox-label"><span class="check-icon"></span>ご出産</label>
            </div>
            <div class="c-check-wrapper">
              <input v-model="form.motiveForSearch" type="checkbox" value="お子様のご進学" id="お子様のご進学">
              <label for="お子様のご進学" class="c-checkbox-label"><span class="check-icon"></span>お子様のご進学</label>
            </div>
            <div class="c-check-wrapper">
              <input v-model="form.motiveForSearch" type="checkbox" value="手狭になった" id="手狭になった">
              <label for="手狭になった" class="c-checkbox-label"><span class="check-icon"></span>手狭になった</label>
            </div>
            <div class="c-check-wrapper">
              <input v-model="form.motiveForSearch" type="checkbox" value="その他" id="その他">
              <label for="その他" class="c-checkbox-label"><span class="check-icon"></span>その他（下記にご入力ください）</label>
            </div>
            <div class="inner-input-wrapper">
              <ValidatedInput
                v-model="form.motiveForSearchAdditional"
                :disabled="!form.motiveForSearch.includes('その他')"
                placeholder=""
                type="text"
                name="きっかけ"
                id="current-rent"
                :rules="form.motiveForSearch.includes('その他') ? 'required' : ''"
              />
            </div>
          </validation-wrapper>
        </div>
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="otherRequirments">ご希望の間取り（複数可）<span class="required">必須</span></label>
          <div class="c-check-wrapper">
            <input type="checkbox" id="1K/DK/LDK" value="1K/DK/LDK" v-model="form.desiredFloorPlan">
            <label for="1K/DK/LDK"><span class="check-icon"></span>1K/DK/LDK</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="2K/DK/LDK" value="2K/DK/LDK" v-model="form.desiredFloorPlan">
            <label for="2K/DK/LDK"><span class="check-icon"></span>2K/DK/LDK</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="3K/DK/LDK" value="3K/DK/LDK" v-model="form.desiredFloorPlan">
            <label for="3K/DK/LDK"><span class="check-icon"></span>3K/DK/LDK</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="4K/DK/LDK" value="4K/DK/LDK" v-model="form.desiredFloorPlan">
            <label for="4K/DK/LDK"><span class="check-icon"></span>4K/DK/LDK</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="5K以上" value="5K以上" v-model="form.desiredFloorPlan">
            <label for="5K以上"><span class="check-icon"></span>5K以上</label>
          </div>
        </div> -->
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="family-size">ご希望の沿線<span class="required">必須</span></label>
          <div id="standard-field-input-wrapper" class="inner-input-wrapper">
            <div class="inner-input-wrapper inner-input-wrapper-fullscreen-short">
              <ValidatedInput
               v-model="form.desiredLine" placeholder="" type="text" name="ご希望の線" id="ご希望の線" rules="required"
              />
              <span class="input-suffix">線</span>
              <ValidatedInput
               v-model="form.desiredStation" placeholder="" type="text" name="ご希望の駅" id="ご希望の駅" rules="required"
              />
              <span class="input-suffix">駅</span>
            </div>
          </div>
        </div> -->
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="income">最寄駅からの所要時間希望<span class="required">必須</span></label>
          <div class="input-wrapper">
            <ValidatedSelect class="select-wrapper inner-input-wrapper" :items="sampleStationThings" rules="required" name="最寄駅からの所要時間希望" v-model="form.desiredTimeToStation" id="desired-area" placeholder="選択してください" valueKey="name" nameKey="name" />
          </div>
        </div> -->
        <!-- <div class="profile-change-field">
          <label class="p-form-title" for="otherRequirments">ご希望条件（複数可）<span class="required">必須</span></label>
          <div class="c-check-wrapper">
            <input type="checkbox" id="駐車場2台可" value="駐車場2台可" v-model="form.otherRequirements">
            <label for="駐車場2台可"><span class="check-icon"></span>駐車場2台可</label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="南向き" value="南向き" v-model="form.otherRequirements">
            <label for="南向き"> <span class="check-icon"></span> 南向き </label>
          </div>
          <div class="c-check-wrapper">
            <input type="checkbox" id="LDK15畳以上" value="LDK15畳以上" v-model="form.otherRequirements">
            <label for="LDK15畳以上"> <span class="check-icon"></span> LDK15畳以上 </label>
          </div>
        </div> -->
        <common-agree-check v-model="agreeChecked" @clear="agreeTooltip = false" :error="agreeTooltip" :disabled="submitting" class="agree-check-wrapper">
          個人情報保護方針と会員規約に同意のうえ送信してください。
        </common-agree-check>
        <div class="policy-wrapper">
          <a href="https://ki-group.co.jp/policy/" target="_blank" class="c-privacy-policy">
            <img id="my-page-icon" src="@/assets/icon-document.png" alt="">
            <p>個人情報保護方針（プライバシーポリシー）</p>
          </a>
          <a href="https://ki-group.co.jp/member/agreement/" target="_blank" class="c-contract">
            <img id="my-page-icon" src="@/assets/icon-document.png" alt="">
            <p>会員規約（利用規約）</p>
          </a>
        </div>
        <p v-if="err.isErr" class="p-errmsg">
          <span>
            <img src="@/assets/attention.png" alt="エラー" width="22" height="22" />
          </span>
          {{ err.msg }}
        </p>
        <input
          v-if="submitting"
          disabled
          type="submit"
          name="ユーザ情報変更"
          value="変更中です・・・"
          class="submit-button disabled-button round-button"
          />
        <input
          v-else-if="!agreeChecked"
          @click="showAgreeTooltip"
          type="button"
          class="submit-button disabled-button round-button"
          name="login"
          value="規約に同意して確認画面へ進む"
        />
        <input
          v-else
          type="submit"
          name="ユーザ情報変更"
          value="規約に同意して確認画面へ進む"
          class="submit-button round-button"
          />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';

import ValidatedInput from '@/components/common/validation/ValidatedInput';
import PrefCitySelect from '@/components/common/PrefCitySelect';

import ValidatedTelephoneField from '@/components/common/validation/telephone/ValidatedTelephoneField';
import ValidatedZipField from '@/components/common/validation/zip/ValidatedZipField';
import ValidationWrapper from '@/components/common/validation/ValidationWrapper';
// import ValidatedDateOfBirthField from '@/components/common/validation/date-of-birth/ValidatedDateOfBirthField';
import ValidatedSelect from '@/components/common/validation/ValidatedSelect';
import CommonAgreeCheck from '@/components/parts/CommonAgreeCheck';
import MixinAPI from '@/plugins/mixin-api';

// import { incomes, budgets } from '@/utils/incomesBudgetsData';

const priceRangesLower = require('@/utils/price-data/desiredPriceRangesLower');
const priceRangesUpper = require('@/utils/price-data/desiredPriceRangesUpper');

export default {
  name: 'MemberRegistForm',
  props: ['preflist', 'limitedPrefList'],
  mixins: [MixinAPI],
  components: { ValidationObserver, ValidatedInput, PrefCitySelect, ValidatedTelephoneField, ValidatedZipField, CommonAgreeCheck, ValidatedSelect, ValidationWrapper },
  data() {
    return {
      err: {
        isErr: false,
        msg: '',
      },
      list: {},
      // incomes,
      // budgets,
      priceRangesLower,
      priceRangesUpper,
      form: {
        email: '',
        password: '',
        passwordConfirm: '',
        sei: '',
        mei: '',
        seikana: '',
        meikana: '',
        zip: '',
        address: '',
        addressLocal: '',
        tel: '',
        prefecture: '',
        // dateOfBirth: '',
        // familySize: '',
        // currentPropertyStatus: '賃貸',
        desiredMonthlyPrice: '',
        // daysOff: [],
        // income: '',
        // budget: '',
        // replacement: true,
        motiveForSearch: [],
        motiveForSearchAdditional: '',
        desiredPriceRangeUpper: '9999999999999',
        desiredPriceRangeLower: '0',
        desiredKind: [],
        // desiredFloorPlan: [],
        desiredAreaPref: '',
        desiredAreaCity: '',
        // desiredLine: '',
        // desiredStation: '',
        // desiredTimeToStation: '',
        // otherRequirements: [],
      },
      submitting: false,
      agreeChecked: false,
      agreeTooltip: false,
    };
  },
  mounted() {
    const querystring = window.location.search;
    this.query = [...new URLSearchParams(querystring).entries()]
      .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});
    this.form.email = this.query.email;
    // this.preFill();
  },
  watch: {
  // eslint-disable-next-line func-names
    'form.motiveForSearch': function (newValue) {
      if (!newValue.includes('その他')) {
        this.form.motiveForSearchAdditional = '';
      }
    },
  },
  methods: {
    hideAgreeTooltip() {
      this.agreeTooltip = false;
    },
    preFill() {
      this.form = {
        email: 'test@test.com',
        password: 'sometimeago123',
        passwordConfirm: 'sometimeago123',
        sei: 'test',
        mei: 'test',
        seikana: 'test',
        meikana: 'test',
        zip: '141-0041',
        address: '久慈市',
        addressLocal: 'test address',
        tel: '032-1233-3123',
        prefecture: '岩手県',
        // dateOfBirth: '',
        // familySize: '',
        // currentPropertyStatus: '賃貸',
        desiredMonthlyPrice: '10',
        // daysOff: [],
        // income: '',
        // budget: '',
        // replacement: true,
        motiveForSearch: ['ご出産'],
        motiveForSearchAdditional: '',
        desiredPriceRangeUpper: '9999999999999',
        desiredPriceRangeLower: '0',
        desiredKind: ['中古マンション'],
        // desiredFloorPlan: [],
        desiredAreaPref: '',
        desiredAreaCity: '',
        // desiredLine: '',
        // desiredStation: '',
        // desiredTimeToStation: '',
        // otherRequirements: [],
      };
    },
    showAgreeTooltip() {
      this.agreeTooltip = true;
    },
    async onSubmit() {
      this.err.isErr = false;
      this.err.msg = '';
      this.$emit('updated', 'confirm', this.form);
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
@import "../../../assets/style/parts_responsive.scss";

.p-form {
  input {
    height: 32px;
  }
}


#user-fixed-email {
  font-size: 16px;
  margin-top: 7px;
  margin-left: 6px;
}

.p-standard-h1 {
  text-align: center;
  margin: 0px;
  padding: 30px 0;
}

#profile-change-form {
  padding: 20px;

  .profile-change-field {
    padding: 12px 0;
    font-size: 16px;
    display: flex;
    flex-wrap: wrap;
    min-height:44px;

    ::v-deep input,
    ::v-deep select {
      width: 100%;
      margin-top: 0px;
      height: 34px;
    }

    .c-radios-wrapper {
      padding: 12px 0;
      display: flex;
      justify-content: center;

      .c-radio-wrapper {
        cursor: pointer;
        position: relative;
        padding: 0px 32px;
      }
    }

    input[type=radio] {
      display:none;
    }

    input[type=radio]:checked + label {
        background-image: url(@/assets/checked_radio_button@2x.png);
        background-repeat: no-repeat;
        background-size: 100%;
        height: 20px;
        width: 20px;
        position: absolute;
        bottom: -3px;
        left: 0px;
        cursor: pointer;
    }

    input[type=radio] + label {
        background-image: url(@/assets/unchecked_radio_button@2x.png);
        background-size: 100%;
        background-repeat: no-repeat;
        height: 20px;
        width: 20px;
        position: absolute;
        bottom: -3px;
        left: 0px;
        cursor: pointer;
    }

    .c-check-wrapper {
      position: relative;
      margin-top: 9px;
      margin-right: 22px;
      margin-bottom: 10px;
    }

    input[type=checkbox] {
      display: none;
    }

    input[type=checkbox]:checked + label > .check-icon {
      background-image: url(@/assets/checkbox-rounded-checked@2x.png);
      background-repeat: no-repeat;
      background-size: 100%;
      height: 24px;
      width: 24px;
      position: absolute;
      bottom: 2px;
      left: 0;
      cursor: pointer;
    }

    input[type=checkbox] + label > .check-icon {
      background-image: url(@/assets/checkbox-rounded-unchecked@2x.png);
      background-size: 86%;
      background-repeat: no-repeat;
      height: 24px;
      width: 24px;
      position: absolute;
      bottom: 0px;
      bottom: 1px;
      left: 0;
      cursor: pointer;
    }

    .c-checkbox-label {
      font-weight: 400;
      display: flex;
      align-items: center;
      margin: 0;
      padding: 0;
      width: 100%;
      margin-left: 32px;
      padding-bottom: 6px;
      font-size: 14px;
      cursor: pointer;
    }

    .input-wrapper {
      display: flex;
      flex-wrap: wrap;
      width: 100%;


      input {
        width: 100%;
        margin-top: 0px;
        height: 34px;
      }

      &::v-deep .address-select-wrapper {
        display: flex;
        margin-top: 10px;
        width: 100%;

        .select-wrapper{
          flex: 1
        }
        .select-wrapper:first-child {
          margin-right: 8px;
        }
        select {
          width: 100%;
        }

      }
    }
    #standard-field-input-wrapper {
      width: 54%;
      .inner-input-wrapper {
        position: relative;
      }
    }
    .c-input-finance-field-width {
      width: 94px;
    }
    .c-price-separator {
      font-size: 20px;
      color: #555555;
      display: block;
      padding: 8px;
      display: flex;
      margin: auto 0;
    }
    label {
      font-size: 16px;
      font-weight: bold;
      width: 100%;
      height: 24px;
      span {
        bottom: 4px;
        &.required {
          margin-left: 1em;
          padding: 6px;
          font-size: 12px;
          color: white;
          background-color: red;
          position: relative;
          bottom: 2px;
        }
        &.optional {
          margin-left: 1em;
          padding: 6px;
          font-size: 12px;
          color: white;
          background-color: #707070;
          position: relative;
          bottom: 2px;
        }
      }
    }

    &.desired-rent-field {
      input {
        width: 60%;
      }
    }
  }

  .double-input {
    input {
      flex: 1;
      margin-right: 8px;
    }

  }
}

.agree-check-wrapper {
  margin-top: 26px;
}


.c-price-select-inner-input-wrapper {
  width: 141px;
}
.c-contract,
.c-privacy-policy {
  font-size: 14px;
  padding-left: 4px;
  margin-top: 8px;
  display: flex;
  align-items: center;

  p {
    margin-left: 4px;
  }
}

  #desired-area-field {
    ::v-deep .address-select-wrapper {
      margin-top: 0px !important;
    }
  }

@media (min-width: 640px) {

  .card-wrapper {
    margin-bottom: 40px !important;
  }

  #profile-change-form {
    width: 678px;
    margin: auto;
    padding: 0;
    .profile-change-field {
      align-items: center;
      padding: 6px 0;

      &.align-start {
        align-items: start;
        label {
          margin-top: 5px;
        }
      }

      input,
      select {
        width: 100%;
      }
      .input-wrapper {
        width: 57%;
        input {
          width: 100%;
        }
       &::v-deep .address-select-wrapper {
          width: 75%;
        }
      }
      #desired-rent-input-wrapper {
        width: 57%;
      }
      label {
        padding-right: 14px;
        height: 100%;
        width: 43%;
        align-self: start;
        padding-top: 4px;
        text-align: left;
        margin-top: 2px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .c-label-subtitle-motive {
        margin-right: 52px;
      }
    }


    .inner-input-wrapper {
      width: 75%;
    }

    .login-field {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      label {
        width: 30%;
      }
      .input-wrapper {
        margin-top: 0px;
        width: 64%;

      }
    }
  }


  .c-input-finance-field-width {
    width: 86px;
  }

  .c-price-select-inner-input-wrapper {
    width: 169px;
  }

  .policy-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
}

</style>
